import clsx from 'clsx';
import styles from './style.module.less';
import { Image, Button } from '@bfe/moly';
import {
  useFm,
  useParams,
  useScreenType,
  useSetParams,
  useToast,
} from '@web3/base-hooks';
import {
  origin,
  isBrowser,
  publicAssetsPath,
  WalletType,
} from '@web3/base-utils';
import IconHot from '@/assets/svg/icon-hot.svg';
import {
  // useCurrentWallet,
  // useUserInfo,
  useConnectWalletModal,
} from '@web3fe/infra';
import useHomeStore from '@/store/home';
import { useMemo, useState } from 'react';
import { Switch, Case, Default } from 'react-if';
import { ClaimStatus, PointsType, WalletBase } from '@/types';
import { pointsTypes } from '@/config';
import { postClaimtTypePoints, postMediaTypePoints } from '@/services/home';
import IconComleted from '@/assets/svg/icon-comleted.svg';
import IconOngoing from '@/assets/svg/icon-ongoing.svg';
import { useWallet } from '@/hooks/wallet';
import { ConnectX, CallbackParam } from './dialog/ConnetX';
import { NoSSR } from '@web3/base-components';
import { Page } from '@/config/track-config';
import { CheckAssetsListButton } from '@/components/CheckAssetsListButton';

export const SectionNewUser = () => {
  const [mediaLoading, setMediaLoading] = useState<boolean>(false);
  const [createLoading, setCreateLoading] = useState<boolean>(false);
  const [trade100Loading, setTrade100Loading] = useState<boolean>(false);
  const [showConnectX, setShowConnectX] = useState(false);
  const { isMobile } = useScreenType();
  const fm = useFm();
  const { supportCommonTask, walletId, walletType, twitterConnectCodeKey } =
    useWallet();
  const { toastSuccess, toastFail } = useToast();
  const { locale } = useParams();
  const { setSearchParams } = useSetParams();

  const connectWallet = useConnectWalletModal();
  const {
    fetchWalletTypePoints,
    fetchWalletTotalPoints,
    walletConfig,
    walletTypePoints,
  } = useHomeStore();
  const paramsBase = useMemo(
    () => ({
      walletId,
      walletType,
    }),
    [walletId, walletType]
  );
  const mediaPoints = useMemo(
    () =>
      walletTypePoints.filter((item) => item.type === PointsType.socialmedia),
    [walletTypePoints]
  );
  // console.log(mediaPoints);
  const createPoints = useMemo(
    () =>
      walletTypePoints.filter((item) => item.type === PointsType.createWallet),
    [walletTypePoints]
  );
  // console.log(createPoints);
  const trade100Points = useMemo(
    () => walletTypePoints.filter((item) => item.type === PointsType.dex100),
    [walletTypePoints]
  );
  // console.log(trade100Points);

  const refreshData = async () => {
    fetchWalletTypePoints({
      ...paramsBase,
      type: walletType === WalletType.CLOUD ? PointsType.wsot : pointsTypes,
    });
    fetchWalletTotalPoints(paramsBase);
  };

  const doMediaSubmit = async ({ code, type, searchParams }: CallbackParam) => {
    if (code) {
      localStorage.setItem(twitterConnectCodeKey, code);
    }
    if (type && type !== 'follow') return;
    setMediaLoading(true);

    const params: WalletBase & {
      accessToken?: string;
      refreshToken?: string;
    } = {
      ...paramsBase,
      accessToken:
        code || localStorage.getItem(twitterConnectCodeKey) || 'accessToken',
      refreshToken: 'refreshToken',
    };
    const res = await postMediaTypePoints(params);

    if (res.success) {
      toastSuccess('Claim success!');
      refreshData();
    } else {
      toastFail(res.message);
    }
    setMediaLoading(false);
    if (code && isBrowser) {
      searchParams.delete('code');
      searchParams.delete('state');
      searchParams.delete('type');
      searchParams.delete('locale');
      setSearchParams(searchParams);
    }
  };

  const handleClick = async (type: PointsType) => {
    if (!supportCommonTask) {
      connectWallet.show();
      return;
    }
    // console.log('handleClick', type);

    switch (type) {
      case PointsType.createWallet:
        setCreateLoading(true);
        break;
      case PointsType.dex100:
        if (trade100Points[0].status !== ClaimStatus.yes) {
          window.open(`${origin}/${locale}/web3/dex`);
          return;
        } else {
          setTrade100Loading(true);
        }
        break;
    }
    try {
      const res = await postClaimtTypePoints({
        ...paramsBase,
        type: type as number,
      });
      console.log(res);

      if (res.success) {
        toastSuccess('Claim success!');
        refreshData();
      } else {
        toastFail(res.message);
      }
    } catch (error) {
      console.log(error);
    }
    setCreateLoading(false);
    setTrade100Loading(false);
  };

  const handleTwitterAuthSuccess = async (code: string) => {
    if (!supportCommonTask) return;

    // 存储认证码
    localStorage.setItem(twitterConnectCodeKey, code);

    // 关闭弹窗
    setShowConnectX(false);

    // 显示成功提示
    toastSuccess(fm('connectSuccessfully'));

    // 可以选择在这里打开 Twitter 关注页面
    window.open('https://x.com/Bybit_Web3', '_blank');
  };

  return (
    <section className={clsx(styles['section-wrap'], 'mt-6 bg-area p-8')}>
      <div className={clsx('flex gap-4')}>
        <Image
          className={clsx(
            styles['task-icon'],
            isMobile ? 'w-12 h-12' : 'w-15 h-15'
          )}
          src={publicAssetsPath('/png/home/task-newuser.png')}
          alt="dexpro"
        />
        <div>
          <h3
            className={clsx(
              'flex items-center font-semibold',
              isMobile ? 'text-base' : 'text-2xl'
            )}
          >
            {fm('newUserTask')}
            <IconHot
              className={clsx('ml-1', isMobile ? 'w-5 h-5' : 'w-6 h-6')}
              viewBox="0 0 25 24"
            />
          </h3>
          <p
            className={clsx(
              ' text-gray-t2 font-light line-clamp-2 mt-2',
              isMobile ? 'text-xs' : 'text-sm'
            )}
          >
            {fm('completeTasksGetPts', {
              dexTrade: walletConfig.dexProAmount,
            })}
          </p>
        </div>
      </div>
      <div
        className={clsx(
          'bg-card flex items-center justify-between py-6 px-4 mt-4 relative'
        )}
      >
        <div>
          <h4 className="text-xl font-medium flex items-center gap-2">
            <Image
              className={clsx(
                styles['task-icon'],
                isMobile ? 'w-5 h-5' : 'w-6 h-6'
              )}
              src={publicAssetsPath('/png/upcoming/task-media.png')}
              alt="wallet"
            />
            {fm('followSocialMedia1')}
          </h4>
          <p>
            <span className="text-gray-t2 text-xs mt-[2px] mr-2">
              {fm('followAcctBybitWeb3X')}
            </span>
            <span className="text-xs text-gray-t2 mr-2">
              {fm('minWalletAssetTenU', {
                capital: walletConfig.capital,
              })}
            </span>
            <CheckAssetsListButton />
          </p>
        </div>
        <Button
          variant={'secondary'}
          className="text-base w-56 h-12"
          loading={mediaLoading}
          disabled={
            supportCommonTask && mediaPoints[0]?.status !== ClaimStatus.yes
          }
          data-spm-even="Web3UserClick"
          data-spm-data={JSON.stringify({
            page_name: Page.HomePage,
            button_name: 'Web3Points_FollowX',
          })}
          onClick={() => {
            if (!supportCommonTask) {
              connectWallet.show();
              return;
            }
            if (mediaPoints[0]?.status === ClaimStatus.no) {
              toastFail(
                fm('walletAssetLessTenU', {
                  capital: walletConfig.capital,
                })
              );
              return;
            }
            if (mediaPoints[0]?.status === ClaimStatus.yes) {
              const storageCode = localStorage.getItem(twitterConnectCodeKey);
              if (storageCode) {
                window.open('https://x.com/Bybit_Web3');
                doMediaSubmit({});
              } else {
                setShowConnectX(true);
              }
            } else {
              doMediaSubmit({});
            }
          }}
        >
          <Switch>
            <Case
              condition={
                supportCommonTask && mediaPoints[0]?.status == ClaimStatus.no
              }
            >
              {fm('insufficientBalance')}
            </Case>
            <Case
              condition={
                supportCommonTask && mediaPoints[0]?.status === ClaimStatus.done
              }
            >
              <span className="flex gap-[6px] text-[#20B26C] items-center">
                <IconComleted />
                {fm('pointsRec', {
                  point: mediaPoints[0]?.point,
                })}
              </span>
            </Case>
            <Default>{fm('goFollow')}</Default>
          </Switch>
        </Button>
        {supportCommonTask && mediaPoints[0]?.status !== ClaimStatus.done && (
          <span
            className={clsx(
              styles['tip'],
              styles['tip-ongoing'],
              'text-sm text-static-black font-medium'
            )}
          >
            <IconOngoing />
            {fm('ongoing')}
          </span>
        )}
      </div>

      {/* 创建或导入钱包 */}
      <div
        className={clsx(
          'bg-card flex items-center justify-between py-6 px-4 mt-4 relative'
        )}
      >
        <div>
          <h4 className="text-xl font-medium flex items-center gap-2">
            <Image
              className={clsx(
                styles['task-icon'],
                isMobile ? 'w-5 h-5' : 'w-6 h-6'
              )}
              src={publicAssetsPath('/png/upcoming/task-wallet.png')}
              alt="wallet"
            />
            {fm('createOrImportWallet')}
          </h4>
          <p>
            <span className="text-gray-t2 text-xs mt-[2px] mr-2">
              {fm('createOrImportKey')}
            </span>
            <span className="text-xs text-gray-t2 mr-2">
              {fm('minWalletAssetTenU', {
                capital: walletConfig.capital,
              })}
            </span>
            <CheckAssetsListButton />
          </p>
        </div>
        <Button
          variant={
            supportCommonTask && createPoints[0]?.status === ClaimStatus.yes
              ? 'primary'
              : 'secondary'
          }
          className="text-base w-56 h-12"
          loading={createLoading}
          disabled={
            supportCommonTask && createPoints[0]?.status !== ClaimStatus.yes
          }
          data-spm-even="Web3UserClick"
          data-spm-data={JSON.stringify({
            page_name: Page.HomePage,
            button_name: 'Web3Points_CreateWallet',
          })}
          onClick={() => handleClick(PointsType.createWallet)}
        >
          <Switch>
            <Case condition={!supportCommonTask}>{fm('goCreate')}</Case>
            <Case
              condition={
                supportCommonTask && createPoints[0]?.status === ClaimStatus.no
              }
            >
              {fm('insufficientBalance')}
            </Case>
            <Case
              condition={
                supportCommonTask && createPoints[0]?.status === ClaimStatus.yes
              }
            >
              {fm('receive')}
            </Case>
            <Case
              condition={
                supportCommonTask &&
                createPoints[0]?.status === ClaimStatus.done
              }
            >
              <span className="flex gap-[6px] text-[#20B26C] items-center">
                <IconComleted />
                {fm('pointsRec', {
                  point: createPoints[0]?.point,
                })}
              </span>
            </Case>
          </Switch>
        </Button>
        {supportCommonTask && createPoints[0]?.status !== ClaimStatus.done && (
          <span
            className={clsx(
              styles['tip'],
              styles['tip-ongoing'],
              'text-sm text-static-black font-medium'
            )}
          >
            <IconOngoing />
            {fm('ongoing')}
          </span>
        )}
      </div>

      {/*  dex总交易额达到100U */}
      <div
        className={clsx(
          'bg-card flex items-center justify-between py-6 px-4 mt-4 relative'
        )}
      >
        <div>
          <h4 className="text-xl font-medium flex items-center gap-2">
            <Image
              className={clsx(
                styles['task-icon'],
                isMobile ? 'w-5 h-5' : 'w-6 h-6'
              )}
              src={publicAssetsPath('/png/upcoming/task-dex.png')}
              alt="wallet"
            />
            {fm('dexProTrade')}
          </h4>
          <p className="text-gray-t2 text-xs mt-[2px]">
            {fm('walletTradeMin', {
              dexTrade: walletConfig.dexProAmount,
            })}
          </p>
        </div>
        <Button
          variant={
            supportCommonTask && trade100Points[0]?.status === ClaimStatus.yes
              ? 'primary'
              : 'secondary'
          }
          className="text-base w-56 h-12"
          loading={trade100Loading}
          disabled={
            supportCommonTask && trade100Points[0]?.status === ClaimStatus.done
          }
          data-spm-even="Web3UserClick"
          data-spm-data={JSON.stringify({
            page_name: Page.HomePage,
            button_name: 'Web3Points_Trade100',
          })}
          onClick={() => {
            handleClick(PointsType.dex100);
          }}
        >
          <Switch>
            <Case
              condition={
                !supportCommonTask ||
                trade100Points[0]?.status === ClaimStatus.no
              }
            >
              {fm('toTrade')}
            </Case>
            <Case
              condition={
                supportCommonTask &&
                trade100Points[0]?.status === ClaimStatus.yes
              }
            >
              {fm('receive')}
            </Case>
            <Case
              condition={
                supportCommonTask &&
                trade100Points[0]?.status === ClaimStatus.done
              }
            >
              <span className="flex gap-[6px] text-[#20B26C] items-center">
                <IconComleted />
                {fm('pointsRec', {
                  point: trade100Points[0]?.point,
                })}
              </span>
            </Case>
          </Switch>
        </Button>
        {supportCommonTask &&
          trade100Points[0]?.status !== ClaimStatus.done && (
            <span
              className={clsx(
                styles['tip'],
                styles['tip-ongoing'],
                'text-sm text-static-black font-medium'
              )}
            >
              <IconOngoing />
              {fm('ongoing')}
            </span>
          )}
      </div>
      <NoSSR>
        <ConnectX
          show={showConnectX}
          onConnect={handleTwitterAuthSuccess}
          onCancel={() => setShowConnectX(false)}
        />
      </NoSSR>
    </section>
  );
};
